var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", { staticClass: "pb-2" }, [
          _vm._v(
            _vm._s(_vm.$t("message.booking.new_booking.subscription_title"))
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-stretch text-center" }, [
          _c(
            "div",
            {
              staticClass:
                "col-6 card card-body flex-items mr-1 pointer-item shadow-sm",
              class: { "panel-service-active": _vm.subscriptionTypeId === 1 },
              on: {
                click: function($event) {
                  return _vm.$parent.applySubscription(1)
                }
              }
            },
            [
              _c("div", { staticClass: "text-primary text-remark" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.booking.new_booking.subscription")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "mt-4" }, [
                _vm._v(_vm._s(_vm.$t("message.subscription.every_2_weeks")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4 text-remark text-pink" }, [
                _vm._v(_vm._s(_vm.$t("message.subscription.save_5")))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-6 card card-body flex-items ml-1 pointer-item shadow-sm",
              class: { "panel-service-active": _vm.subscriptionTypeId === 2 },
              on: {
                click: function($event) {
                  return _vm.$parent.applySubscription(2)
                }
              }
            },
            [
              _c("div", { staticClass: "text-primary text-remark" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.booking.new_booking.subscription")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "mt-4" }, [
                _vm._v(_vm._s(_vm.$t("message.subscription.weekly")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4 text-remark text-pink mt-auto" }, [
                _vm._v(_vm._s(_vm.$t("message.subscription.save_7")))
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b867f64", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b867f64","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/newSteps/components/SubscriptionType.vue
// module id = 1706
// module chunks = 0